import { generateRowsData } from "./generatePropertyGroupRowsData";
import { columns } from "./propertyGroupColumns";

export const generatePropertyGroupTableData = (rawData) => {
    var rowsData = generateRowsData(rawData)
    return {rows: rowsData, columns: columns }
}